<template>
  <div class="error-box no-fav-box">
    <!-- <p class="txt">正在跳转到PIM</p> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  mounted() {
    this.redirectToPim();
  },
  methods: {
    redirectToPim() {
      const currentHost = window.location.hostname;
      let targetHost = '';

      // 根据当前域名确定目标域名
      if (currentHost === 'lundbeck-kol360-mobile.dev.lekinsights.cn') {
        targetHost = 'lundbeck-pim-mobile-dev.lekinsight.cn';
      } else if (currentHost === 'hcp360-mobile-sandbox.lundbecksys.cn') {
        targetHost = 'pim-sandbox.lundbecksys.cn';
      } else if (currentHost === 'hcp360-mobile.lundbecksys.cn') {
        targetHost = 'pim.lundbecksys.cn';
      } else {
        // 默认跳转到开发环境
        targetHost = 'lundbeck-pim-mobile-dev.lekinsights.cn';
      }

      // 构建目标URL，更换path为 /pages/auth/authorize，保持原有的查询参数和hash
      const targetUrl = `${window.location.protocol}//${targetHost}/pages/auth/authorize${window.location.search}${window.location.hash}`;

      // 跳转到目标URL
      window.location.href = targetUrl;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/var.scss';
.no-fav-box {
  min-width: 250px;
  padding-top: 60px;
  .txt {
    font-size: 13px;
    color: #707070;
    text-align: center;
    & + .txt {
      margin-top: 20px;
    }
  }
}
</style>
